import { ProductOption } from "./ProductOption.js";

export const restrictedProductOptionsForExpress: ProductOption[] = [
	ProductOption.GlutenFreeVariant,
	ProductOption.LactoseFreeVariant,
	ProductOption.CreamColor,
	ProductOption.LyingPhoto,
	ProductOption.StandingPhotos,
];
